import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { FaBookmark, FaChevronLeft, FaChevronRight, FaCrown } from "react-icons/fa";
import "./Tables.css";

const TopStudents = ({ students = [] }) => {
  const visibleCount = 5;
  const [startIndex, setStartIndex] = useState(0);

  const handlePrev = () => {
    if (startIndex > 0) setStartIndex((prev) => prev - 1);
  };

  const handleNext = () => {
    if (startIndex + visibleCount < students.length) setStartIndex((prev) => prev + 1);
  };

  return (
    <div className="top-students-wrapper">
      <Button
        variant="light"
        onClick={handlePrev}
        disabled={startIndex === 0}
        className="nav-button left"
      >
        <FaChevronLeft />
      </Button>

      <div className="carousel-container">
        <div
          className="carousel-track"
          style={{
            transform: `translateX(-${startIndex * (180 + 12)}px)`,
            width: `${students.length * (180 + 12)}px`,
          }}
        >
          {students && students.map((student, index) => (
            <div key={student.id} className="student-card">
              <FaBookmark className="bookmark-icon" />

              {index === 0 && (
                <FaCrown className="crown-icon" />
              )}

              <div className="student-info">
                <div className="student-name">{student.full_name}</div>
                <a
                  href={student.git}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="student-git"
                >
                  {student.git}
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>

      <Button
        variant="light"
        onClick={handleNext}
        disabled={startIndex + visibleCount >= students.length}
        className="nav-button right"
      >
        <FaChevronRight />
      </Button>
    </div>
  );
};

export default TopStudents;
